import RestService from '../services/rest';

async function getAllPacks(
  limit,
  skip,
  search,
  orderBy,
  field,
  status = '',
  pricingType = '',
  dateFrom = '',
  dateTo = '',
) {
  const queryParams = [
    `limit=${limit}`,
    `skip=${skip}`,
    `search=${search}`,
    `orderBy=${orderBy}`,
    `field=${field}`,
    `status=${status}`,
    `pricingType=${pricingType}`,
    `dateFrom=${dateFrom}`,
    `dateTo=${dateTo}`,
  ].join('&');

  return RestService.getAuthenticated(`panel/packs/all?${queryParams}`);
}

async function getPacksOptions(productId, search) {
  return RestService.getAuthenticated(
    `panel/packs/productsOptions?productId=${productId}&search=${search}`,
  );
}

async function getResultFormulaProduct(id, meters = 1, points = 1) {
  return RestService.getAuthenticated(
    `panel/packs/resultFormulaProduct?id=${id}&meters=${meters}&points=${points}`,
  );
}

async function createPack(newPack) {
  return RestService.postAuthenticated(
    'panel/packs/create', newPack,
  );
}

async function updatePack(updPack) {
  return RestService.putAuthenticated(
    'panel/packs/update', updPack,
  );
}

async function updatePackStatus(id, status) {
  return RestService.putAuthenticated(
    'panel/packs/update/status', { id, status },
  );
}

async function deletePack(id) {
  return RestService.postAuthenticated(
    'panel/packs/delete', { id },
  );
}

async function getSearchProducts(limit = 10, skip = 0, search = '') {
  return RestService.getAuthenticated(
    `panel/packs/searchProducts?limit=${limit}&skip=${skip}&search=${search}`,
  );
}

async function getPackDetail(id) {
  return RestService.getAuthenticated(`panel/packs/detail?id=${id}`);
}

async function uploadCsvPacks(file) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated('panel/packs/csv/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

async function uploadPackImage(file, packId) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated(`panel/packs/image?id=${packId}`, fd, {
    'Content-Type': 'multipart/form-data',
  });
}

async function getCsvPacksModel() {
  const response = await RestService.getAuthenticated('panel/packs/csv/model', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Modelo_Importação_Packs CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

export default {
  getAllPacks,
  getPacksOptions,
  getResultFormulaProduct,
  createPack,
  updatePack,
  updatePackStatus,
  deletePack,
  getSearchProducts,
  getPackDetail,
  uploadCsvPacks,
  getCsvPacksModel,
  uploadPackImage,
};
